import HTMLTemplate from './template.html'
import './styles.scss'
import User from '../../modules/user'
import ClientPortalAPIService from './../../services/api/ClientPortal/ApiService'
import moment from 'moment'
import { SideNavigation } from '../SideNavigation/SideNavigation'
import AvsecAlerts from '../../modules/avsecAlerts'
import Airport from '../../modules/airport'
import { findIfAlertsAreInAirportRange } from '../../services/EventsService'

let loopingAlertsInterval = null

export const AlertNotification = (() => {
    var vueComponent = {
        data() {
            return {
                hasPermissionToView: false,
                notificationOut: false,
                alerts: [],
                currentlyDisplayedAlertIndex: 0,
                previousDisplayedAlertIndex: -1
            }
        },
        mounted() {
            User.getUserPermissions().then(permissions => {
                let isCrewCheck = !!permissions && permissions.includes('crew_locator') || permissions.includes('crew_check_automation')
                if (isCrewCheck) {
                    this.hasPermissionToView = true
                }

                if (this.hasPermissionToView) {
                    ClientPortalAPIService.getCriticalAlerts('').then(alerts => {
                        User.getLocalUserSettings().then(settings => {
                            let foundAlerts = []
                            if (settings.latestDismissedCriticalAlertID !== '') {
                                let indexOfLastDismissedAlert = alerts.findIndex(alert => alert.AlertId === settings.latestDismissedCriticalAlertID)
                                foundAlerts = alerts.slice(0, indexOfLastDismissedAlert)
                            } else {
                                foundAlerts = alerts
                            }

                            this.alerts = foundAlerts.filter(alert => !alert.IsArchived)
                            SideNavigation.$data.isCriticalAlert = this.alerts.length > 0 ? true : false
                            this.startLoopingAlerts()
                        })
                    })
                }

                this.getMonitoredAirportsAlerts()
                this.startAlertsObserver()
            })
        },
        methods: {
            getCriticalAlerts(type) {
                if (this.hasPermissionToView) {
                    ClientPortalAPIService.getCriticalAlerts('').then(alerts => {
                        if (typeof alerts === 'object') {
                            alerts = alerts.map(alert => { alert.Alert.type = 'criticalAlerts'; return alert })
                            User.getLocalUserSettings().then(settings => {
                                let foundAlerts = []
                                if (settings.latestDismissedCriticalAlertID !== '') {
                                    let indexOfLastDismissedAlert = alerts.findIndex(alert => alert.AlertId === settings.latestDismissedCriticalAlertID)
                                    foundAlerts = alerts.slice(0, indexOfLastDismissedAlert)
                                } else {
                                    foundAlerts = alerts
                                }

                                // If the alert is not in the alert list, add it
                                foundAlerts.forEach(alert => {
                                    if (!alert.IsArchived) {
                                        let foundAlert = this.alerts.find(res => res.AlertId === alert.AlertId && res.Alert.type === 'criticalAlerts')
                                        if (!foundAlert) {
                                            this.alerts.push(alert)
                                        }
                                    }
                                })

                                // If the alert is not in the alert list, remove it
                                this.alerts.forEach((alert, index) => {
                                    if (alert.Alert.type === 'criticalAlerts') {
                                        let foundAlert = foundAlerts.find(res => res.AlertId === alert.AlertId)
                                        if (!foundAlert) {
                                            this.alerts.splice(index, 1)
                                        }
                                    }
                                })

                                if (type !== 'observer') {
                                    this.startLoopingAlerts()
                                }
                            })
                        }
                    })
                }
            },
            getMonitoredAirportsAlerts(type) {
                AvsecAlerts.getModuleLatestAlerts().then(latestAlerts => {
                    User.getLocalUserSettings().then(settings => {
                        let foundAlerts = []
                        if (settings.latestDismissedAviationAlertID?.length > 0) {
                            foundAlerts = latestAlerts.filter(alert => !settings.latestDismissedAviationAlertID.includes(alert.NodeId))
                        } else {
                            foundAlerts = latestAlerts
                        }
                        let finalAlerts = []
                        if (settings?.followedAirports?.length > 0) {
                            settings.followedAirports.filter(res => {
                                const airportDetails = Airport.getAirportByICAOCode(res)
                                const airportCoordinates = [airportDetails?.Lat, airportDetails?.Lng]
                                foundAlerts.filter(alert => {
                                    if (alert?.AffectedAirports?.includes(res)) {
                                        alert.watchedAirport = res
                                        finalAlerts.push(alert)
                                        return true
                                    }
                                    if (!!alert.AffectedLocation) {
                                        let distanceFromAirport = findIfAlertsAreInAirportRange(alert.AffectedLocation, airportCoordinates, 50)
                                        if (distanceFromAirport && distanceFromAirport <= 50) {
                                            alert.watchedAirport = res
                                            finalAlerts.push(alert)
                                        }
                                    }
                                    return false
                                })
                            })
                        }
                        const avsecAlert = finalAlerts.map(alert => {
                            alert.Alert = {
                                TitleLocation: alert.watchedAirport,
                                AlertId: alert.NodeId,
                                NodeId: alert.NodeId,
                                Title: alert.Title,
                                EventStart: alert.Date,
                                ActiveFrom: alert.CreatedDate,
                                type: 'avsecAlert',
                                // TitleLocation: alert.SelectedCountry,
                                IsBreaking: alert.IsBreaking,
                                Severity: alert.Severity,
                                isAirportOnly: alert.isAirportOnly
                            }
                            return alert
                        })

                        //If the alert is not in the alert list, add it
                        avsecAlert.forEach(alert => {
                            let foundAlert = this.alerts.find(res => res.Alert.AlertId === alert.Alert.AlertId && res.Alert.type === 'avsecAlert')
                            if (!foundAlert) {
                                this.alerts.push(alert)
                            }
                        })

                        //If the alert is not in the alert list, remove it
                        this.alerts.forEach((alert, index) => {
                            if (alert.Alert.type === 'avsecAlert') {
                                let foundAlert = avsecAlert.find(res => res.Alert.AlertId === alert.Alert.AlertId)
                                if (!foundAlert) {
                                    this.alerts.splice(index, 1)
                                }
                            }
                        })

                        setTimeout(() => {
                            if (type !== 'observer') {
                                this.startLoopingAlerts()
                            }
                        }, 100)
                    })
                })
            },
            startAlertsObserver() {
                const ONE_MINUTE = 1000 * 60
                window.setInterval(() => {
                    this.getCriticalAlerts('observer')
                    this.getMonitoredAirportsAlerts('observer')
                }, ONE_MINUTE)
            },
            resetAlerts() {
                this.alerts = []
                this.getCriticalAlerts()
                this.getMonitoredAirportsAlerts()
            },
            getCriticalAlertFormattedDate(eventStartDate, activeFromDate) {
                if (!!eventStartDate) {
                    if (eventStartDate.indexOf('T00:00:00') > -1) {
                        return moment.utc(eventStartDate).format('DD MMM YYYY') + ' UTC'
                    } else {
                        return moment.utc(eventStartDate).format('hh:mm DD MMM YYYY') + ' UTC'
                    }
                } else {
                    return moment.utc(activeFromDate).format('DD MMM YYYY') + ' UTC'
                }
            },
            determineRedirection() {
                const alertData = this.alerts?.[this.currentlyDisplayedAlertIndex]
                if (alertData.NodeId) {
                    AvsecAlerts.showAlert(alertData.NodeId, alertData?.AffectedLocation?.Coordinates ? 'location' : 'alert')
                } else {
                    window.location.href = '/dashboard.html'
                }
            },
            startLoopingAlerts() {
                window.clearInterval(loopingAlertsInterval)
                loopingAlertsInterval = window.setInterval(() => {
                    this.displayAlerts()
                }, 6000)
            },
            displayAlerts() {
                if (this.alerts.length > 1) {
                    this.previousDisplayedAlertIndex = this.currentlyDisplayedAlertIndex
                    if (this.currentlyDisplayedAlertIndex < this.alerts.length - 1) {
                        this.currentlyDisplayedAlertIndex += 1
                    } else {
                        this.currentlyDisplayedAlertIndex = 0
                    }
                }
            },
            dismissAlerts(alert) {
                this.notificationOut = true
                User.getLocalUserSettings().then(settings => {
                    let updatedUserSettings = settings
                    if (alert?.NodeId) {
                        // push the node id into the array and save it
                        updatedUserSettings.latestDismissedAviationAlertID = updatedUserSettings.latestDismissedAviationAlertID || []
                        if (!updatedUserSettings.latestDismissedAviationAlertID.includes(alert.NodeId)) {
                            updatedUserSettings.latestDismissedAviationAlertID.push(alert.NodeId)
                        }
                    } else {
                        updatedUserSettings.latestDismissedCriticalAlertID = this.alerts[0].AlertId
                    }
                    SideNavigation.$data.isCriticalAlert = false
                    User.updateUserSettings(updatedUserSettings)
                    this.resetAlerts()
                    this.displayAlerts()
                    setTimeout(() => {
                        this.notificationOut = false
                    }, 200)
                })

                // window.clearInterval(loopingAlertsInterval)
            },
            isAvsecAlert() {
                return this.alerts?.[this.currentlyDisplayedAlertIndex]?.Alert?.type === 'avsecAlert'
            },
            getAlertType() {
                let alert = this.alerts?.[this.currentlyDisplayedAlertIndex]?.Alert
                let alertType = ''
                if (alert?.type === 'avsecAlert') {
                    if (alert?.isAirportOnly) {
                        alertType = 'airport-only-alert'
                    } else if (alert?.IsBreaking) {
                        alertType = 'breaking-alert'
                    } else {
                        alertType = 'aviation-alert'
                    }
                } else {
                    if (alert.Service === 'Security') {
                        alertType = 'security-alert'
                    } else if (alert.Service === 'Medical') {
                        alertType = 'medical-alert'
                    }
                }
                return alertType
            }
        },
        template: HTMLTemplate
    }

    const DOMElement = document.getElementById('vue-alert-notification')
    if (DOMElement === null) {
        return null
    } else {
        return Vue.createApp(vueComponent).mount(DOMElement)
    }
})();